import { types } from './actions';

const initialState = {
  areCustomPartAttrsSaving: false,
  customPartAttrs: [],
  isEditingCustomPartAttrs: false,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.CUSTOM_PART_ATTRS_FETCH_SUCCESS:
      return {
        ...state,
        customPartAttrs: payload.customPartAttrs,
      };
    case types.CUSTOM_PART_ATTRS_UPDATE_ERROR:
      return {
        ...state,
        areCustomPartAttrsSaving: false,
      };
    case types.CUSTOM_PART_ATTRS_UPDATE_REQUEST:
      return {
        ...state,
        areCustomPartAttrsSaving: true,
      };
    case types.CUSTOM_PART_ATTRS_UPDATE_SUCCESS:
      return {
        ...state,
        areCustomPartAttrsSaving: false,
        customPartAttrs: payload.customPartAttrs,
        isEditingCustomPartAttrs: false,
      };
    case types.CUSTOM_PART_ATTRS_EDIT_REQUEST:
      return {
        ...state,
        isEditingCustomPartAttrs: true,
      };
    case types.CUSTOM_PART_ATTRS_EDIT_CANCEL:
      return {
        ...state,
        isEditingCustomPartAttrs: false,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) => state.modules.settings.company.customPartAttrs;

export const getAreCustomPartAttrsSaving = (state) =>
  getScope(state).areCustomPartAttrsSaving;

export const getCustomPartAttrs = (state) => getScope(state).customPartAttrs;

export const getIsEditingCustomPartAttrs = (state) =>
  getScope(state).isEditingCustomPartAttrs;
